import React, { useState } from "react";
import { t } from "i18next";
import BaseAlertModal from "./BaseAlertModal";
import CheckBox from "../CheckBox/CheckBox";
import promotionCodesAPI from "../../API/promotionCodes.api";
import { SuccessAlert } from "../../utils/Alerts";
import { isEmpty } from "lodash";
import { handleExternalLink } from "../../utils/ExternalLinksHelper";

const PromoCodesExportModal = ({ isVisible, setIsVisible, couponId }) => {
    const [selectedOptions, setSelectedOptions] = useState({
        active: false,
        redeemed: false,
        expired: false,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const renderCheckboxes = () => {
        const options = [
            { label: t("active"), value: "active" },
            { label: t("redeemed"), value: "redeemed" },
            { label: t("expired"), value: "expired" },
        ];

        const onOptionChange = (e) => {
            setSelectedOptions((prevOptions) => ({
                ...prevOptions,
                [e.target.name]: !prevOptions[[e.target.name]],
            }));
        };

        return options.map((option, index) => {
            return (
                <CheckBox
                    key={index}
                    name={option.value}
                    label={option.label}
                    onChangeHandler={onOptionChange}
                    checked={selectedOptions[option.value]}
                />
            );
        });
    };

    const handleExportPromoCodes = async () => {
        setIsSubmitting(true);

        if (!isEmpty(couponId)) {
            const payload = {
                couponId: couponId,
                isActive: selectedOptions.active,
                isExpired: selectedOptions.expired,
                isRedeemed: selectedOptions.redeemed,
            };

            const result = await promotionCodesAPI.exportPromotionCodes(
                payload
            );

            if (result?.url) {
                handleExternalLink(result.url);
                SuccessAlert(t("promoCodesExportSuccessMessage"));
                setSelectedOptions({
                    active: false,
                    redeemed: false,
                    expired: false,
                });
            }
        }

        setIsSubmitting(false);
    };

    return (
        <>
            <BaseAlertModal
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                title={`${t("export")} ${t("promoCodes")}`}
                isSubmitting={isSubmitting}
                action={{
                    name: t("export"),
                    submitAction: handleExportPromoCodes,
                }}
            >
                <div className="flex w-full justify-around p-6">
                    <div className="flex flex-col input-group">
                        {renderCheckboxes()}
                    </div>
                    <div className="text-6xl text-primary-color-blue">
                        <i className="fas fa-file-csv"></i>
                    </div>
                </div>
            </BaseAlertModal>
        </>
    );
};

export default PromoCodesExportModal;
